module.exports = {"350582001":"青阳街道","350582002":"梅岭街道","350582003":"西园街道","350582004":"罗山街道","350582005":"新塘街道","350582006":"灵源街道","350582101":"安海镇","350582102":"磁灶镇","350582103":"陈埭镇","350582104":"东石镇","350582105":"深沪镇","350582106":"金井镇","350582107":"池店镇","350582109":"内坑镇","350582110":"龙湖镇","350582111":"永和镇","350582112":"英林镇","350582113":"紫帽镇","350582114":"西滨镇","350582400":"安平开发区","350582401":"晋江市经济开发区","350582402":"泉州出口加工区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350582.json
// module id = 1207
// module chunks = 0